/**
* Stepped Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stepped Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'stepped-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.stepped-content .stepped-content__steps-nav button, .stepped-content .stepped-content__step-arrows button' ).on( 'click', function() {
        $( this ).closest( '.stepped-content' ).find( '.stepped-content__steps-nav button, .stepped-content__step' ).removeClass( 'is-active' );

        $( this ).closest( '.stepped-content' ).find( '.stepped-content__steps-nav button:nth-child(' + ( parseInt( $( this ).attr( 'data-step' ) ) + 1 ) + '), .stepped-content__step:nth-child(' + ( parseInt( $( this ).attr( 'data-step' ) ) + 1 ) + ')' ).addClass( 'is-active' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stepped-content', COMPONENT );
} )( app );
